import { useCallback, useEffect } from 'react'
import { useDispatch, useSelector } from 'react-redux'

import { useCleanupRedux } from '../../common/hooks'
import { apolloService } from '../../common/services'

import { LOCATION_TYPE_CATEGORY_QUERY } from '../graphql/queries'
import { FETCH_LOCATION_TYPE_CATEGORY } from '../redux/action-types'
import { cleanupFetchLocationTypeCategory } from '../redux/actions'

const useLocationTypeCategoryQuery = id => {
  const dispatch = useDispatch()
  useCleanupRedux(cleanupFetchLocationTypeCategory)

  const { isLoading, error, data } = useSelector(
    store => store.locationTypes.locationTypeCategory,
  )

  const refetch = useCallback(
    id =>
      apolloService.query(
        LOCATION_TYPE_CATEGORY_QUERY,
        { id },
        dispatch,
        FETCH_LOCATION_TYPE_CATEGORY,
      ),

    [dispatch],
  )

  useEffect(() => {
    refetch(id)
  }, [id, refetch])

  return { isLoading, error, data }
}

export default useLocationTypeCategoryQuery
